<template>
  <div ref="autoCompleteComponent" class="relative">
    <InputText
      ref="trigger"
      v-model="inputValue"
      :name="name"
      :label="label"
      :placeholder="placeholder"
      clearable
      autocomplete="off"
      @focus="$event.target.select()"
      @click="open = true"
    >
      <template #prefix>
        <Icon src="bold/magnifying_glass" :size="ComponentSize.default" />
      </template>
    </InputText>
    <div
      v-if="open"
      class="bg-bgr-primary shadow-on-top absolute top-14 left-0 z-30 max-h-[323px] w-full overflow-auto rounded-lg p-1.5 text-left"
    >
      <div
        v-for="option in filteredOptions"
        :key="option.value"
        class="group hover:bg-state-bgr-hover hover:text-state-fgr-hover flex items-center gap-1 rounded-lg px-3 py-1 transition-all duration-300"
        @click="setOption(option)"
      >
        <Entry :entry="option" :search="inputValue" />
        <Button
          class="pointer-events-none ml-auto opacity-0 group-hover:pointer-events-auto group-hover:opacity-100"
          type="button"
          :variant="ButtonVariant.Tertiary"
          icon-only
          @click.stop="emitDelete(option)"
        >
          <Icon src="X" />
        </Button>
      </div>
      <Overlay v-if="loading" class="h-16 min-h-16" />
      <div v-if="filteredOptions.length === 0 && !loading" class="text-body-default flex rounded-lg px-3 py-1.5">
        {{ emptyText }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import outsideClick from "../../composables/useOutsideClick";
  import Entry from "./Entry.vue";

  const open = ref<boolean>(false);

  const autoCompleteComponent = ref();

  const emit = defineEmits(["update:modelValue", "delete"]);

  const props = withDefaults(
    defineProps<{
      emptyText?: string;
      label?: string;
      loading?: boolean;
      name?: string;
      options?: any[];
      placeholder?: string;
    }>(),
    {
      emptyText: "",
      label: "",
      loading: false,
      name: "",
      options: () => [],
      placeholder: "",
    }
  );

  const setOption = (option: object) => {
    inputValue.value = option.label;
    emit("update:modelValue", option.value);
    open.value = false;
  };

  const emitDelete = (option: object) => {
    emit("delete", option.value);
  };

  outsideClick(autoCompleteComponent, () => {
    open.value = false;
  });

  const filteredOptions = computed(() => {
    const entries = props.options.filter((option) => {
      if (option.label && inputValue.value) {
        if (option.label.toLowerCase().includes(inputValue.value.toLowerCase())) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });
    return entries;
  });

  const { value: inputValue } = useField(() => props.name, undefined, {
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });
</script>
